import React from "react";
import { FormattedDate, FormattedMessage } from "react-intl";

import { Button } from "src/common/components/Button";
import { Modal } from "src/common/components/Modal";
import { TextCenter } from "src/common/components/TextAlign";
import { TextDoc } from "src/common/components/TextDoc";
import { api } from "src/common/utils/api";
import { useAuthState } from "src/features/auth";
import { useRelevantChanges } from "src/features/changelog/changes/hooks";
import { genericMessages } from "src/messages/generic";

export const LastChangeModal: React.FunctionComponent = () => {
	const { user } = useAuthState();
	const [isOpen, setOpen] = React.useState(false);

	const changes = useRelevantChanges();
	const { date, content: Content } = changes[0];

	React.useEffect(() => {
		if (user === null) {
			console.log("user was null");
			return;
		}
		if (user.lastViewedMessage !== date) {
			setOpen(true);
			api.put("/profile/lastViewedMessage", { messageId: date });
		}
	}, [user, date]);

	const onCloseLatestVersionModal = React.useCallback(() => {
		setOpen(false);
	}, []);

	return isOpen ? (
		<Modal
			isFullSize={false}
			title={<FormattedMessage {...genericMessages.changes} />}
			onClose={onCloseLatestVersionModal}
			footer={
				<TextCenter>
					<Button type="button" onClick={onCloseLatestVersionModal}>
						<FormattedMessage {...genericMessages.close} />
					</Button>
				</TextCenter>
			}
		>
			<TextDoc key={date}>
				<h1>
					<FormattedDate
						value={date}
						year="numeric"
						month="numeric"
						day="numeric"
					/>
				</h1>
				<Content />
			</TextDoc>
		</Modal>
	) : null;
};
